import React, { useEffect, useRef, useState } from 'react';
import { parseJSON, anchorTagColorChanger, decodeHTMLTags } from '../Utils';
import * as Rating from '../../Ratings/Ratings';
import { RATING_SMILEY_ID_MAPPING, RATING_TYPES } from '../Constants';
import Cards from './Cards/Cards';

import styled from 'styled-components';
import Input from '../../../FlyfishComponents/Input';

// import Radio from '../../../FlyfishComponents/Radio';
import Button from '../../../FlyfishComponents/Button';
import ProductDisplayFullScreen from '../../ProductDisplayFullScreen';
import ShowComplementaryDesc from '../../ShowComplementaryDesc';
import ProductDisplayFullScreenEnhanced from '../../ProductDisplayFullScreenEnhanced';

import GetInTouch from '../../GetInTouch';
import NonProductFullScreen from '../../NonProductFullScreen';
import ProductSelectionCard from '../../ProductSelectionCard';
import MonacoTheme from '../../Flyfish/MonacoTheme';
import EcomChatTheme from '../../Flyfish/EcomChatTheme';
import { loadStateSession } from '../../../FlyfishComponents/flyfishutils/utils';
import Modal from '../../../FlyfishComponents/Modal';
import { Snackbar } from '@mui/material';

const EcomChatThemeDiv = styled.div`
	display: flex;
	gap: 32px;
	justify-content: space-between;
	padding: 12px 16px;
	padding-right: 0;

	& > .list-carousel-message {
		width: fit-content;
		max-width: 1074px;
		color: var(--srvMsgColor, #ffffff);
		padding: 10px;
		margin-left: 0 !important;
		line-height: 1.3;
		padding: 0;
	}
	& > .live-chat-icon {
		display: flex;
		align-items: center;
	}
	@media (min-width: 320px) and (max-width: 480px) {
		&.monaco-list-carousel-message-with-svg {
			display: block !important;
			gap: 0 !important;
			padding: unset !important;
			margin-bottom: 16px;
			& > .live-chat-icon {
				cursor: pointer;
				position: absolute;
				right: 0;
				margin-top: 12px !important;
			}
			& > .list-carousel-message {
				margin-top: 0;
				border-radius: initial;
				padding: 12px 16px !important;
			}
		}
	}
`;
const MonacoThemeDiv = styled.div`
	display: flex;
	gap: 32px;
	justify-content: space-between;
	padding: 12px 16px;
	padding-right: 0;

	& > .list-carousel-message {
		width: fit-content;
		max-width: 1074px;
		color: var(--srvMsgColor, #ffffff);
		padding: 10px;
		margin-left: 0 !important;
		padding: 0;
	}
	& > .live-chat-icon {
		display: flex;
		align-items: center;
	}
	@media (min-width: 320px) and (max-width: 480px) {
		&.monaco-list-carousel-message-with-svg {
			display: block !important;
			gap: 0 !important;
			padding: unset !important;
			margin-bottom: 16px;
			& > .live-chat-icon {
				cursor: pointer;
				position: absolute;
				right: 0;
				margin-top: 12px !important;
			}
			& > .list-carousel-message {
				margin-top: 0;
				border-radius: initial;
				padding: 12px 16px !important;
			}
		}
	}
`;

const FFModalNew = styled.div`
	& > .modal-overlay-bot {
		justify-content: center !important;
		& > .modal-container-bot {
			width: 43% !important;
			max-width: 423px;
			height: unset !important;
			padding: 24px;
			padding-top: 0;
			padding-right: 0;
			& > header {
				padding: 0 !important;
			}
			& > .body {
				padding-right: 24px;
			}
			@media screen and (max-width: 500px) {
				width: 94% !important;
			}
		}
	}
`;

const FFRating = styled.div`
	&.ff-thumbs-feedback-rating {
		display: flex;
		align-items: center;
		gap: 6px;
		padding-bottom: 12px;
		margin-left: 16px;
		padding-bottom: 12px;

		& + .MuiSnackbar-root {
			& > div {
				display: flex;
				justify-content: center;
				background: #f5f5f5;
				color: black;
				box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.25);
				border-radius: 0;
				border: 1px solid #e1e1e1;
				font-family: var(--fontFamily);
			}
		}
		& + div:not(.feedback-modal-for-monaco) {
			margin-bottom: 24px;
			& > .ff-input {
				max-width: unset;
				& .MuiInputBase-root {
					border-radius: 0;
					font-family: var(--fontFamily);
				}
			}
			& + .custom-button {
				display: flex;
				justify-content: center;
				& > button {
					border-radius: 0;
					background-color: black !important;
					padding: 5px 12px;
					& > div {
						font-family: var(--fontFamily);
					}
					& > .button-loader {
						display: flex;
					}
				}
			}
		}

		& > svg {
			width: 24px;
			cursor: pointer;
			&:hover {
				& path {
					fill-opacity: 0.8;
				}
			}
		}
		&.change {
			gap: 24px;
			margin-bottom: 15px;
			justify-content: center;
			& > svg {
				width: 36px;
				height: 36px;
			}
		}
	}
`;
const Simple = (props: any) => {
	let msg = props.data;
	let metaData = props.metaData;

	const ratingTypeId = props.ratingTypeId;
	const isRatingTask = props.isRatingTask;
	const handleSubmit = props.handleSubmit;

	if (msg.indexOf('<p>#SF#</p>') > -1) {
		msg = parseJSON(msg.replace('<p>#SF#</p>', ''));
		return <Cards langCode={props.langCode} {...msg.card} />;
	}
	let msg1 = msg.replace(/[[\]]/g, '');
	msg1 = msg1.replace(/^(\s+<br( \/)?>)*|(<br( \/)?>\s)*$/gm, ''); //NOSONAR
	let finalHTML = anchorTagColorChanger(decodeHTMLTags(msg1));

	const [selectedStars, setSelectedStars] = React.useState(0);

	const [productId, setProductId] = React.useState('');
	const [productName, setProductName] = React.useState('');
	const [complementary, setComplementary] = useState(false);
	const [filledFlyfishthumbsupSVG, setFilledFlyfishthumbsupSVG] =
		useState(false);
	const [filledFlyfishthumbsdownSVG, setFilledFlyfishthumbsdownSVG] =
		useState(false);
	const [showFFModal, setShowFFModal] = useState(false);
	const [valueFeedback, setValueFeedback] = useState('');
	const [showThanksModal, setShowThanksModal] = useState(false);
	const [thankModalMessage, setThankModalMessage] = useState(
		'Thanks for your feedback!'
	);
	const [submitLoader, setSubmitLoader] = useState(false);
	const [feedBackSubmitted, setFeedbackSubmitted] = useState(false);
	// if (finalHTML.indexOf('<a target') > -1 && checkoutCount < 1) {
	// 	setCheckoutCount(checkoutCount + 1);
	// 	let response = finalHTML.split('"')[3];
	// 	window.open(response);
	// }
	const ratingFFIcons = () => {
		return (
			<>
				{(loadStateSession('selectedTheme') === 'monaco' ||
					loadStateSession('selectedTheme') === 'E-commerce Chat') &&
				showFFModal ? (
					<FFModalNew className='Simple feedback-modal-for-monaco'>
						<Modal
							header=''
							headerCloseBtn
							footerNotReq
							onClose={() => {
								setShowFFModal(false);
								if (!feedBackSubmitted) {
									setFilledFlyfishthumbsdownSVG(false);
									setFilledFlyfishthumbsupSVG(false);
								}
							}}
							actionButtons={<></>}
						>
							<div>
								{ratingzFF(true)}
								<Input
									maxRows={3}
									multiline
									value={valueFeedback}
									onChange={(e) => setValueFeedback(e.target.value)}
									placeholder='Please tell us more'
								/>
								<Button
									loading={submitLoader}
									onClick={() => {
										setSubmitLoader(true);
										let payload = {
											botId: loadStateSession('botID'),
											conversationId: loadStateSession('conversationId'),
											feedBackText: valueFeedback,
											id: 0,
											messageId: loadStateSession('messageId'),
											msgRating: filledFlyfishthumbsupSVG ? 4 : 2,
											rating: 0,
										};
										fetch(
											window['BASE_URL'] +
												`/configuration/${loadStateSession(
													'tenantID'
												)}/feedBack`,
											{
												credentials: 'include',
												method: 'POST',
												headers: {
													'Content-Type': 'application/json',
													'x-tenant-id': loadStateSession('tenantID'),
													Authorization: `Bearer ${loadStateSession('token')}`,
												},
												body: JSON.stringify(payload),
											}
										)
											.then((data) => data.json())
											.then((response) => {
												if (response.status.toLowerCase() === 'success') {
													setShowThanksModal(true);
													setSubmitLoader(false);
													setFeedbackSubmitted(true);
												} else {
													setShowThanksModal(true);
													setSubmitLoader(false);
													setFeedbackSubmitted(false);
												}
												setShowFFModal(false);
												setTimeout(() => {
													setShowThanksModal(false);
												}, 2000);
											})
											.catch((error) => {
												setShowThanksModal(true);
												setSubmitLoader(false);
												setTimeout(() => {
													setShowThanksModal(false);
												}, 2000);
												setFeedbackSubmitted(false);
												setShowFFModal(false);
											});
									}}
								>
									Submit
								</Button>
							</div>
						</Modal>
					</FFModalNew>
				) : null}
				{(loadStateSession('selectedTheme') === 'monaco' ||
					loadStateSession('selectedTheme') === 'E-commerce Chat') &&
				showThanksModal ? (
					<>
						<Snackbar
							color='inherit'
							open={showThanksModal}
							message={thankModalMessage}
							autoHideDuration={3000}
							anchorOrigin={{
								vertical: 'bottom',
								horizontal: 'center',
							}}
						/>
					</>
				) : null}
			</>
		);
	};
	const ratingzFF = (changeHeight?: boolean) => {
		return (
			<FFRating
				className={`Simple ff-thumbs-feedback-rating ${
					changeHeight ? 'change' : ''
				}`}
			>
				{filledFlyfishthumbsupSVG ? (
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='24'
						height='24'
						viewBox='0 0 24 24'
						fill='none'
					>
						<g id='thumb_up_chatgpt_filled'>
							<path
								id='Vector'
								d='M12.5921 2.50381C12.8047 2.13011 13.2317 1.93501 13.652 2.01941C15.5627 2.40311 16.7246 4.36081 16.1515 6.23081L15.303 9.00001L17.0142 9.00001C19.6408 9.00001 21.5485 11.5079 20.8574 14.0524L19.4993 19.0524C19.0267 20.7927 17.4526 22 15.6562 22L9.96717 22C8.86897 21.9978 7.97937 21.1032 7.97937 20L7.97937 9.00001L8.31727 9.00001C8.67467 9.00001 9.00467 8.80771 9.18197 8.49611L12.5921 2.50381Z'
								fill='black'
							/>
							<path
								id='Vector_2'
								d='M5.9876 9.00001C4.3376 9.00001 3 10.3431 3 12L3 19C3 20.6568 4.3376 22 5.9876 22L6.5206 22C6.1816 21.4116 5.9876 20.7285 5.9876 20L5.9876 9.00001Z'
								fill='black'
							/>
						</g>
					</svg>
				) : (
					<svg
						onClick={() => {
							if (filledFlyfishthumbsupSVG) {
							} else {
								setShowFFModal(true);
							}
							setFilledFlyfishthumbsdownSVG(false);
							setFilledFlyfishthumbsupSVG(true);
						}}
						className={`UP ${filledFlyfishthumbsupSVG}`}
						xmlns='http://www.w3.org/2000/svg'
						width='24'
						height='24'
						viewBox='0 0 24 24'
						fill='none'
					>
						<g id='thumb_up_chatgpt'>
							<path
								id='Vector'
								fill-rule='evenodd'
								clip-rule='evenodd'
								d='M12.1318 2.50389C12.3321 2.15338 12.7235 1.95768 13.124 2.00775L13.5778 2.06447C16.0449 2.37286 17.636 4.83353 16.9048 7.20993L16.354 8.99999H17.0722C19.7097 8.99999 21.6253 11.5079 20.9313 14.0525L19.5677 19.0525C19.0931 20.7927 17.5124 22 15.7086 22H6C4.34315 22 3 20.6568 3 19V12C3 10.3431 4.34315 8.99999 6 8.99999H8C8.25952 8.99999 8.49914 8.86094 8.6279 8.63561L12.1318 2.50389ZM10 20H15.7086C16.6105 20 17.4008 19.3964 17.6381 18.5262L19.0018 13.5262C19.3488 12.2539 18.391 11 17.0722 11H15C14.6827 11 14.3841 10.8494 14.1956 10.5941C14.0071 10.3388 13.9509 10.0092 14.0442 9.70591L14.9932 6.62175C15.3384 5.49984 14.6484 4.34036 13.5319 4.08468L10.3644 9.62789C10.0522 10.1742 9.56691 10.5859 9 10.8098V19C9 19.5523 9.44772 20 10 20ZM7 11V19C7 19.3506 7.06015 19.6872 7.17071 20H6C5.44772 20 5 19.5523 5 19V12C5 11.4477 5.44772 11 6 11H7Z'
								fill='black'
								fill-opacity='0.4'
							/>
						</g>
					</svg>
				)}
				{filledFlyfishthumbsdownSVG ? (
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='24'
						height='24'
						viewBox='0 0 24 24'
						fill='none'
					>
						<g id='thumb_down_chatgpt_filled'>
							<path
								id='Vector'
								d='M11.4079 21.4961C11.1953 21.8698 10.7683 22.0649 10.348 21.9805C8.4373 21.5968 7.27541 19.6391 7.84844 17.7691L8.69697 14.9999H6.98577C4.35915 14.9999 2.45151 12.492 3.14262 9.94747L4.50063 4.94747C4.97329 3.20722 6.54741 1.99994 8.34378 1.99994H14.0328C15.131 2.00207 16.0206 2.89668 16.0206 3.99994V14.9999H15.6827C15.3253 14.9999 14.9953 15.1922 14.818 15.5038L11.4079 21.4961Z'
								fill='black'
							/>
							<path
								id='Vector_2'
								d='M18.0124 14.9999C19.6624 14.9999 21 13.6568 21 11.9999V4.99994C21 3.34308 19.6624 1.99994 18.0124 1.99994H17.4794C17.8184 2.58829 18.0124 3.27136 18.0124 3.99994V14.9999Z'
								fill='black'
							/>
						</g>
					</svg>
				) : (
					<svg
						onClick={() => {
							if (filledFlyfishthumbsdownSVG) {
							} else {
								setShowFFModal(true);
							}
							setFilledFlyfishthumbsdownSVG(true);
							setFilledFlyfishthumbsupSVG(false);
						}}
						className={`DOWN ${filledFlyfishthumbsdownSVG}`}
						xmlns='http://www.w3.org/2000/svg'
						width='24'
						height='24'
						viewBox='0 0 24 24'
						fill='none'
					>
						<g id='thumb_down_chatgpt'>
							<path
								id='Vector'
								fill-rule='evenodd'
								clip-rule='evenodd'
								d='M11.8727 21.4961C11.6725 21.8466 11.2811 22.0423 10.8805 21.9922L10.4267 21.9355C7.95958 21.6271 6.36855 19.1665 7.09975 16.7901L7.65054 15H6.93226C4.29476 15 2.37923 12.4921 3.0732 9.94753L4.43684 4.94753C4.91145 3.20728 6.49209 2 8.29589 2H18.0045C19.6614 2 21.0045 3.34315 21.0045 5V12C21.0045 13.6569 19.6614 15 18.0045 15H16.0045C15.745 15 15.5054 15.1391 15.3766 15.3644L11.8727 21.4961ZM14.0045 4H8.29589C7.39399 4 6.60367 4.60364 6.36637 5.47376L5.00273 10.4738C4.65574 11.746 5.61351 13 6.93226 13H9.00451C9.32185 13 9.62036 13.1506 9.8089 13.4059C9.99743 13.6612 10.0536 13.9908 9.96028 14.2941L9.01131 17.3782C8.6661 18.5002 9.35608 19.6596 10.4726 19.9153L13.6401 14.3721C13.9523 13.8258 14.4376 13.4141 15.0045 13.1902V5C15.0045 4.44772 14.5568 4 14.0045 4ZM17.0045 13V5C17.0045 4.64937 16.9444 4.31278 16.8338 4H18.0045C18.5568 4 19.0045 4.44772 19.0045 5V12C19.0045 12.5523 18.5568 13 18.0045 13H17.0045Z'
								fill='black'
								fill-opacity='0.4'
							/>
						</g>
					</svg>
				)}
			</FFRating>
		);
	};
	if (props.details) {
		return (
			<>
				<div
					className='list-carousel-message'
					dangerouslySetInnerHTML={{ __html: props.data }}
				></div>
				<div style={{ display: 'flex', justifyContent: 'end' }}>
					{props.productData.quicklinks.items.map((item) => {
						return (
							<div
								className={`ff-leads-btn ${props.colorMode}`}
								onClick={() => {
									props.handleSubmit(item.actionText);
								}}
							>
								{item.actionText}
							</div>
						);
					})}
				</div>
				<NonProductFullScreen {...props} />
			</>
		);
	}
	if (props.showProduct == 'DescCard') {
		return <ProductSelectionCard {...props} />;
	}
	if (props.selectedTheme === 'E-commerce Chat') {
		return (
			<>
				<EcomChatThemeDiv
					className='monaco-list-carousel-message-with-svg'
					dangerouslySetInnerHTML={{
						__html: `<div class='list-carousel-message'>${props.data}</div>`,
					}}
				></EcomChatThemeDiv>
				{ratingzFF()}
				{ratingFFIcons()}
				{props.showProduct === true ? (
					<>
						<div style={{ display: 'flex' }}>
							{props.productData.quicklinks.items.map((item) => {
								return (
									<div
										className={`ff-leads-btn ${props.colorMode}`}
										onClick={() => {
											props.handleSubmit(item.actionText);
										}}
									>
										{item.actionText}
									</div>
								);
							})}
						</div>
						<EcomChatTheme {...props} />
					</>
				) : null}
			</>
		);
	}
	if (props.selectedTheme === 'monaco') {
		return (
			<>
				<MonacoThemeDiv
					className='monaco-list-carousel-message-with-svg'
					dangerouslySetInnerHTML={{
						__html: `<div class='list-carousel-message ff-chatbot-body1'>${props.data}</div>
									<div class='live-chat-icon' style="cursor: pointer;"><svg style="pointer-events: none;" xmlns="http://www.w3.org/2000/svg" width="38" height="32.225" viewBox="0 0 38 32.225">
							<g id="Live_chat" data-name="Live chat" transform="translate(-1060.5 -195.004)">
							  <path id="Union_3" data-name="Union 3" d="M25.683,25.5H2A1.5,1.5,0,0,1,.5,24V2A1.5,1.5,0,0,1,2,.5H36A1.5,1.5,0,0,1,37.5,2V24A1.5,1.5,0,0,1,36,25.5H32.744v5.682Z" transform="translate(1060.5 195.004)" fill="#fff" stroke="#707070" stroke-width="1"/>
							  <text id="LIVE_CHAT-2" data-name="LIVE CHAT" transform="translate(1079.5 207.004)" fill="#575757" font-size="10" font-family="Montserrat-SemiBold, Montserrat" font-weight="600"><tspan x="-11" y="0">LIVE</tspan><tspan x="-14" y="10">CHAT</tspan></text>
							</g>
						  </svg></div>`,
					}}
				></MonacoThemeDiv>
				{ratingzFF()}
				{ratingFFIcons()}
				{props.showProduct === true ? (
					<>
						<div style={{ display: 'flex' }}>
							{props.productData.quicklinks.items.map((item) => {
								return (
									<div
										className={`ff-leads-btn ${props.colorMode}`}
										onClick={() => {
											props.handleSubmit(item.actionText);
										}}
									>
										{item.actionText}
									</div>
								);
							})}
						</div>
						<MonacoTheme {...props} />
					</>
				) : null}
			</>
		);
	}
	if (
		props.showProduct == true &&
		(props.selectedTheme == 'Enhanced' || props.selectedTheme == 'Basic')
	) {
		let obj = [];
		props.productData.lists.items[0]
			.filter((item) => item.category === 'Top Products')
			.map((item, index) => {
				return obj.push({
					resourceURL: item.media_link,
					title: item.title,
					price: item.price,
					description: '',
					cardIndex: index.toString(),
					productId: item.product_id,
					currency: item.currency,
					complimentary_product: item.complimentary_products,
					reasonQuery: item.reason_query,
					reasonDesc: item.reason,
				});
			});
		return (
			<>
				<div
					className='list-carousel-message'
					dangerouslySetInnerHTML={{ __html: props.data }}
				></div>
				<div style={{ display: 'flex' }}>
					{props.productData.quicklinks.items.map((item) => {
						return (
							<div
								className={`ff-leads-btn ${props.colorMode}`}
								onClick={() => {
									props.handleSubmit(item.actionText);
								}}
							>
								{item.actionText}
							</div>
						);
					})}
				</div>

				<ProductDisplayFullScreenEnhanced
					selectedButton={props.selectedButton}
					selectedTheme={props.selectedTheme}
					recommendationHeading={props.recommendationHeading}
					showOnHover={props.showOnHover}
					enhanced={true}
					reasonAPI={props.reason}
					getProductDescription={props.getProductDescription}
					addUserResponse={props.addUserResponse}
					createCart={props.createCart}
					colorMode={props.colorMode}
					colorScale={props.colorScale}
					productData={props.productData}
					lists={obj}
					getProductDetails={props.getProductDetails}
					handleSubmit={props.handleSubmit}
					handleSelectedProduct={props.handleSelectedProduct}
					showComplementary={() => {
						setComplementary(true);
					}}
					setProductId={(item) => {
						setProductId(item);
					}}
					setProductName={(item) => {
						setProductName(item);
					}}
					shouldDisableActions={props.shouldDisableActions}
					tenantId={props.tenantId}
					token={props.token}
				/>
				{productId.length > 0 && (
					<ShowComplementaryDesc
						createCart={props.createCart}
						colorMode={props.colorMode}
						colorScale={props.colorScale}
						productData={props.productData}
						getProductDetails={props.getProductDetails}
						handleSubmit={props.handleSubmit}
						handleSelectedProduct={props.handleSelectedProduct}
						productId={productId}
						lists={obj}
						productName={productName}
						showComplementary={() => {
							setComplementary(true);
						}}
						setProductId={(item) => {
							setProductId(item);
						}}
						setProductName={(item) => {
							setProductName(item);
						}}
						tenantId={props.tenantId}
						token={props.token}
					/>
				)}
			</>
		);
	}
	if (props.showProduct == true) {
		let obj = [];
		props.productData.lists.items[0]
			.filter((item) => item.category === 'Top Products')
			.map((item, index) => {
				return obj.push({
					resourceURL: item.media_link,
					title: item.title,
					price: item.price,
					description: '',
					cardIndex: index.toString(),
					productId: item.product_id,
					currency: item.currency,
					complimentary_product: item.complimentary_products,
					reasonQuery: item.reason_query,
					reasonDesc: item.reason,
				});
			});
		return (
			<>
				<div
					className='list-carousel-message'
					dangerouslySetInnerHTML={{ __html: props.data }}
				></div>
				<div style={{ display: 'flex' }}>
					{props.productData.quicklinks.items.map((item) => {
						return (
							<div
								className={`ff-leads-btn ${props.colorMode}`}
								onClick={() => {
									props.handleSubmit(item.actionText);
								}}
							>
								{item.actionText}
							</div>
						);
					})}
				</div>

				<ProductDisplayFullScreen
					reasonAPI={props.reason}
					getProductDescription={props.getProductDescription}
					addUserResponse={props.addUserResponse}
					createCart={props.createCart}
					colorMode={props.colorMode}
					colorScale={props.colorScale}
					productData={props.productData}
					lists={obj}
					getProductDetails={props.getProductDetails}
					handleSubmit={props.handleSubmit}
					handleSelectedProduct={props.handleSelectedProduct}
					showComplementary={() => {
						setComplementary(true);
					}}
					setProductId={(item) => {
						console.log('setProductId', item);
						setProductId(item);
					}}
					setProductName={(item) => {
						console.log('setProductName', item);

						setProductName(item);
					}}
					shouldDisableActions={props.shouldDisableActions}
					tenantId={props.tenantId}
					token={props.token}
				/>
				{productId.length > 0 && (
					<ShowComplementaryDesc
						createCart={props.createCart}
						colorMode={props.colorMode}
						colorScale={props.colorScale}
						productData={props.productData}
						lists={obj}
						getProductDetails={props.getProductDetails}
						handleSubmit={props.handleSubmit}
						handleSelectedProduct={props.handleSelectedProduct}
						productId={productId}
						productName={productName}
						showComplementary={() => {
							setComplementary(true);
						}}
						setProductId={(item) => {
							setProductId(item);
						}}
						setProductName={(item) => {
							setProductName(item);
						}}
						tenantId={props.tenantId}
						token={props.token}
					/>
				)}
			</>
		);
	}

	// if (msg.indexOf('PAYMENTSTATUS')) {
	// 	return  <DisplayCard
	//         	currencyCode='USD'
	// 	         desc="Miss Lavish London Women’s Casual Sleeveless Summer Ankle Length Beach Maxi Long Dress"
	// 			 price="85"
	// 			 rating={4.5}
	// 			 image="https://static.zara.net/photos///2024/V/0/1/p/2331/948/712/2/w/1121/2331948712_1_1_1.jpg?ts=1706788590633"

	//            	/>;
	//  }

	if (msg.indexOf('PAYMENTSTATUS') > -1) {
		return <div>{props.paymentStatus}</div>;
	}
	if (msg.indexOf('PAYMENTURL') > -1) {
		let url = msg.split('PAYMENTURL')[1];
		return (
			<div className='ff-payment'>
				Please click below link to make a payment
				<br />
				<a
					onClick={() => {
						props.handlePaymentStatus(url);
					}}
				>
					{url}
				</a>
			</div>
		);
	}
	// if(msg.indexOf('JSONSplitter')>-1){
	// 	let displaymsg=msg.split('JSONSplitter')[0]
	// 	let product=msg.split('JSONSplitter')[1]
	// 	return(
	// 		<div>
	//           <div className="msg-server">{displaymsg}</div>
	// 		    {JSON.parse(product).products.length>0?
	//             <DisplayProduct metadata={JSON.parse(product).products} handleSubmit={props.handleSubmit}/>
	//             :
	// 			null
	// 			}
	// 		</div>
	// 	)
	// }

	if (msg.substring(0, 9) === 'WORKFLOW-') {
		const cssPtag = {
			outline: '1px solid rgba(128, 128, 128, 0.3)',
			borderRadius: '16px',
			padding: '10px',
			borderTopLeftRadius: 0,
			marginBottom: '20px',
		};

		let chatInput = msg.split('-')[1];
		let checkIndex = props.workflowData
			.map((val, i) => {
				if (val.customName.toLowerCase() === chatInput.toLowerCase()) {
					return i;
				} else {
					return -1;
				}
			})
			.filter((v) => v !== -1)[0];

		let currentWorkflow = 'generateLeads';
		if (checkIndex === 0) {
			currentWorkflow = 'raiseTicket';
		} else if (checkIndex === 1) {
			currentWorkflow = 'generateLeads';
		} else if (checkIndex === 2) {
			currentWorkflow = 'bookAppointment';
		}

		return (
			<>
				<GetInTouch
					noOfTimeCalled={props.index}
					handleSubmit={props.handleSubmit}
					WorkflowData={props.workflowData}
					colorMode={props.colorMode}
					token={props.token}
					botId={props.botId}
					tenantId={props.tenantId}
					conversationId={props.conversationId}
					cssPtag={cssPtag}
					addUserResponse={props.addUserResponse}
					shouldDisableActions={props.shouldDisableActions}
					currentWorkflow={currentWorkflow}
					maxIndex={props.maxIndex}
					EbotId={props.EbotId}
					lang={props.lang}
				/>
			</>
		);
	}
	let msgArray = [];
	if (props.channel === 'whatsapp') {
		if (isRatingTask) {
			if (RATING_SMILEY_ID_MAPPING[ratingTypeId]) {
				for (let i = 0; i < RATING_SMILEY_ID_MAPPING[ratingTypeId].count; i++) {
					msgArray[i] = i + 1;
				}
			}
		}
	}

	const smileyArray = ['😖', '😞', '😐', '😊', '🤩'];
	const stars = '⭐⭐⭐⭐⭐⭐⭐⭐⭐⭐';

	let smileysToRender = 3;
	let indexForRating = 0;

	return (
		<>
			<div className='sf-simple-response '>
				<div
					className='sf-simple-response-content '
					dangerouslySetInnerHTML={{
						__html: finalHTML,
					}}
				/>
				{props.productData && props.productData.lists && (
					<div
						style={{
							display: 'flex',
							justifyContent: 'end',
							marginBottom: '10px',
							marginRight: '-21px',
						}}
					>
						{props.productData.lists.items.map((item) => {
							return (
								<div
									className={`ff-leads-btn ${props.colorMode}`}
									onClick={() => {
										props.handleSubmit(item.actionText);
									}}
								>
									{item.actionText}
								</div>
							);
						})}
					</div>
				)}
				{isRatingTask ? (
					<div
						className={`sf-rating-task `}
						style={{
							paddingTop: '12px',
							minWidth:
								RATING_SMILEY_ID_MAPPING[ratingTypeId] &&
								RATING_SMILEY_ID_MAPPING[ratingTypeId].count === 10
									? '386px'
									: 'fit-content',
						}}
					>
						{props.channel === 'whatsapp' ? (
							RATING_SMILEY_ID_MAPPING[ratingTypeId] &&
							RATING_SMILEY_ID_MAPPING[ratingTypeId].type ===
								RATING_TYPES.Star ? (
								<div>
									{msgArray.map((each, index) => {
										return (
											<>
												<div
													style={{
														display: 'flex',
														alignItems: 'center',
														gap: '3px',
													}}
												>
													<span>{index + 1} </span> {stars.slice(0, index + 1)}
												</div>
												<br />
											</>
										);
									})}
									<p>
										💡 <b>Tip</b> : Please reply with number of stars you want
										to select. For E.g. for{' '}
										{RATING_SMILEY_ID_MAPPING[ratingTypeId].count} stars, say
										<i> {RATING_SMILEY_ID_MAPPING[ratingTypeId].count} </i>
									</p>
								</div>
							) : RATING_SMILEY_ID_MAPPING[ratingTypeId].type ===
							  RATING_TYPES.Smiley ? (
								<div>
									{smileyArray.map((each, index) => {
										RATING_SMILEY_ID_MAPPING[ratingTypeId].count === 3
											? (smileysToRender = 2)
											: (smileysToRender = 1);
										if (index % smileysToRender === 0) {
											indexForRating += 1;
										}
										return (
											index % smileysToRender === 0 && (
												<div>
													<p style={{ fontSize: '18px' }}>
														{indexForRating}. {each}
													</p>
													{smileyArray.length === index + 1 ? '' : <br />}
												</div>
											)
										);
									})}
									<p>
										<br /> 💡 <b>Tip</b> : To select a rating, please enter its
										option number. E.g. say
										<i> {RATING_SMILEY_ID_MAPPING[ratingTypeId].count} </i> to
										select 🤩
									</p>
								</div>
							) : null
						) : RATING_SMILEY_ID_MAPPING[ratingTypeId].type ===
						  RATING_TYPES.Star ? (
							<Rating.StarRating
								number={RATING_SMILEY_ID_MAPPING[ratingTypeId].count}
								filled={selectedStars}
								popUpSnackBar={props.popUpSnackBar}
								onChange={(data: any) => {
									handleSubmit(`${data}`, {}, { isHidden: true });
									setSelectedStars(data);
								}}
								noLabel
								noOutlineHover
								disable={props.shouldDisableActions}
							/>
						) : RATING_SMILEY_ID_MAPPING[ratingTypeId].type ===
						  RATING_TYPES.Smiley ? (
							<Rating.SmileRating
								number={RATING_SMILEY_ID_MAPPING[ratingTypeId].count}
								filled={selectedStars}
								popUpSnackBar={props.popUpSnackBar}
								onChange={(data: any) => {
									handleSubmit(`${data}`, {}, { isHidden: true });
									setSelectedStars(data);
								}}
								noLabel
								noOutlineHover
								disable={props.shouldDisableActions}
							/>
						) : null}
					</div>
				) : null}

				{props.channel === 'whatsapp' ? (
					<p
						style={{
							fontSize: '11px',
							color: '#667781',
							textAlign: 'end',
						}}
					>
						{props.timeStamp}
					</p>
				) : (
					''
				)}
			</div>
		</>
	);
};
export default Simple;
// function useEffect(arg0: () => void, arg1: undefined[]) {
// 	throw new Error('Function not implemented.');
// }
